import {
    BoundarySign,
    ExactFilter,
    ExactSign,
    isExactFilter,
    RangeFilter,
} from 'utils/filter/filter';
import DateTimeExpression from 'utils/filter/expressions/DateTimeExpression';

export type DateTimeFilter = ExactFilter<number | string> | RangeFilter<number>;

export default function buildDateFilterFunction(filter: DateTimeFilter) {
    if (isExactFilter(filter)) {
        const expression = new DateTimeExpression(filter.value);
        if (filter.exactSign === ExactSign.EQ) {
            return expression.testSameDay.bind(expression);
        } else {
            return expression.testNotSameDay.bind(expression);
        }
    }

    const rangeFilter = filter as RangeFilter<number>;
    const lowerFunction = buildDateBoundaryFilterFunction(rangeFilter, 'l');
    const upperFunction = buildDateBoundaryFilterFunction(rangeFilter, 'u');

    return (n: number) => lowerFunction(n) && upperFunction(n);
}

function buildDateBoundaryFilterFunction(
    rangeFilter: RangeFilter<number>,
    boundary: 'l' | 'u'
) {
    const targetValue =
        rangeFilter[boundary === 'l' ? 'lowerValue' : 'upperValue'];
    if (!targetValue) {
        return () => true;
    }

    const expression = new DateTimeExpression(targetValue);
    switch (rangeFilter[boundary === 'l' ? 'lowerSign' : 'upperSign']) {
        case BoundarySign.GTE:
            return expression.testAfterThanOrSameDay.bind(expression);
        case BoundarySign.LTE:
            return expression.testBeforeThanOrSameDay.bind(expression);
        case BoundarySign.GT:
            return expression.testAfterThanDay.bind(expression);
        case BoundarySign.LT:
            return expression.testBeforeThanDay.bind(expression);
        default:
            return () => true;
    }
}
